import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoNext = () => {
  return (
    <g>
      <path d="m1.46 15.7687a.7509.7509 0 0 0 .75 0l12.33-7.1187a.75.75 0 0 0 0-1.2988l-12.33-7.1196a.75.75 0 0 0 -1.125.6494v14.2383a.7487.7487 0 0 0 .375.6494zm1.125-13.5887 10.08 5.82-10.08 5.82z" />
    </g>
  );
};

export default withIcon(IconVideoNext);
